import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateEndLottery',
  standalone: true
})
export class DateEndLotteryPipe implements PipeTransform {

  transform(value: any): unknown {
    
    const today = new Date().getTime();

    const endtDate = new Date(value).getTime();
    
    
    if (endtDate > today) {
      return true;
    }
    return false;
  }

}
